export enum UiMode {
  FARM = 'FARM',
  LIVESTOCK = 'LIVESTOCK',
}
